import { FirebaseApp, initializeApp } from 'firebase/app';

// TODO: maybe use env variables for this
const firebaseConfig = {
  apiKey: 'AIzaSyD50dUbM_ARWY587Q_YXuZd5qeDr8gB_gE',
  authDomain: 'chess-royale-web.firebaseapp.com',
  projectId: 'chess-royale-web',
  storageBucket: 'chess-royale-web.appspot.com',
  messagingSenderId: '409256880625',
  appId: '1:409256880625:web:15925248705702ac5abc50',
  measurementId: 'G-RT93DRBE37',
};

const isClient = typeof window !== 'undefined';

class Firebase {
  instance?: FirebaseApp;

  constructor() {
    // do not run firebase in e2e tests to not exceed daily limit of BigQuery
    if (process.env.ANALYTICS_ENABLED && process.env.NEXT_RUNTIME !== 'testing' && isClient) {
      this.instance = initializeApp(firebaseConfig);
    }
  }
}

export default new Firebase().instance;
